export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}



// WEBPACK FOOTER //
// ../src/util/capitalizeFirstLetter.ts